<dx-popup
  [closeOnOutsideClick]="false"
  [height]="this.height"
  [resizeEnabled]="true"
  [showCloseButton]="false"
  [title]="this.title"
  [width]="this.width"
>
  <div *dxTemplate="let data of 'content'">
    <div class="container">
      
      <div class="header">
        <div class="title">
          After State
        </div>
        <div class="details">
          <div class="adjustment-type">
            <span class="value"> "{{ this.adjustment }}" </span>
          </div>
        </div>
      </div>
      
      <hr style="border-color: dimgray; width: 80%">
      
      <div class="content">
        <dx-scroll-view>
          <div class="state">
            <div class="row" *ngFor="let row of this.previewRows" [style.visibility]="row.removed ? 'collapse' : 'visible'">
              <div class="row-title" [style.color]="row.color">
                <div class="hedge-exclude" *ngIf="this.canDeferOrCancel(row)">
                  <dx-switch [value]="!row.deferred" (onValueChanged)="this.toggleHedgeExcluded(row)"></dx-switch>
                </div>
                <div class="hedge-name">
                  <span *ngIf="row.underlyingDisplayName && this.esHedgingEnabled" class="underlying-badge">{{ row.underlyingDisplayName }}</span>
                  {{ row.label }}
                </div>
                <div class="hedge-remove" (click)="this.onHedgeRemoveRequest(row)" *ngIf="this.canDeferOrCancel(row)">
                  <i class="fa fa-times-circle remove-group"></i>
                </div>
              </div>
              <div class="row-data" [class.excluded]="row.deferred">
                <div class="col before">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="5">Before</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Qty</td>
                      <td>Side</td>
                      <td>Type</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.before" class="row" [style.color]="row.color">
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                      <td>{{ leg.type }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
                <div class="col transaction">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="4">Transaction</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Action</td>
                      <td>Qty</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.transaction" class="row" [style.color]="row.color">
                      <td>{{ leg.operation }}</td>
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
                <div class="col after">
                  <table>
                    <tr class="group-name" [style.color]="row.color">
                      <td colspan="5">After</td>
                    </tr>
                    <tr class="headers" [style.color]="row.color">
                      <td>Qty</td>
                      <td>Side</td>
                      <td>Type</td>
                      <td>Expiration</td>
                      <td>Strike</td>
                    </tr>
                    <tr *ngFor="let leg of row.after" class="row" [style.color]="row.color">
                      <td>{{ leg.qty }}</td>
                      <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                      <td>{{ leg.type }}</td>
                      <td>{{ leg.expiration | etsFriendlyDatePipe:'full' }}</td>
                      <td>{{ leg.strike }}</td>
                    </tr>
                    <tr class="footer">
                      <td colspan="5">&nbsp;</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </dx-scroll-view>
      </div>
      
      <hr style="border-color: dimgray; width: 80%">
      
      <div class="footer">
        <div class="btn apply">
          <dx-button (onClick)="this.onApplyClicked()" [text]="this.btnApplyText"
                     width="100%">
          </dx-button>
        </div>
        <div class="btn close">
          <dx-button (onClick)="this.onCloseClicked()" [text]="this.btnCloseText"
                     width="100%">
          </dx-button>
        </div>
      </div>
    
    </div>
  </div>
</dx-popup>

<ets-generic-confirmation-dialog
  title="Confirm Action">
</ets-generic-confirmation-dialog>
